import {
  DateTime
} from 'luxon';
import TimeRange from '../getTimeRange';
import mergeObj from '../extraUtil/mergeTwoObj';
const dateTimeHashMap = new TimeRange().dateTimeHashMap;
const numeral = require('numeral');

let chart = {
    "showXAxisLine": "0",
    "showYAxisLine": "0",
    "xAxisLineThickness": "1",
    "xAxisLineColor": "#BEB2C8",
    "paletteThemeColor": "#6B7FD7",
    "plotfillalpha": "100",
    "resizeAnimDuration": "0",
    "highColor": "#70ae6e",
    "lowColor": "#ff0000",
    "updateAnimDuration":"0",
    "chartBottomMargin":"10",
    "chartLeftMargin":"10",
    "chartRightMargin":"10",
    "chartTopMargin":"0"
};

export default function dataSourceGenerator(rawData, timeSelectorValue, theme) {
  chart = mergeObj(chart, theme);
  let dataSource = {},
    dataset = [],
    data = [],
    startDate = dateTimeHashMap[timeSelectorValue]['startDate'],
    endDate = dateTimeHashMap[timeSelectorValue]['endDate'],
    startDateInDateTime = DateTime.fromFormat(startDate, 'M/d/yy H:mm'),
    endDateInDateTime = DateTime.fromFormat(endDate, 'M/d/yy H:mm'),
    diffInDays = Math.floor(endDateInDateTime.diff(startDateInDateTime, 'days').values.days),
    billAmount = new Array(diffInDays + 1).fill(0);
  for (let i = 0; i < rawData.length; i++) {
    let numberOfDaysFromStart = Math.floor(DateTime.fromMillis(rawData[i]['expectedShipDate'], 'M/d/yy H:mm').diff(startDateInDateTime, 'days').values.days);
    billAmount[numberOfDaysFromStart] += Math.ceil(parseFloat(rawData[i]['billAmount'].replace(/,/g, '')));
  }
  for (let j = 1; j < billAmount.length; j++) {
    let date = DateTime.fromMillis(startDateInDateTime + (j*86400000)).toFormat('d-MMM-yyyy');
    if (billAmount[j]) {
      data.push({
        value: billAmount[j],
        tooltext: "Date: " + date + "<br>Value: " + numeral(billAmount[j]).format('$0,0')
      });
    }
  }
  dataset.push({
    data: data
  });
  dataSource = {
    chart: chart,
    dataset: dataset
  }
  return dataSource
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/billAmountGenerator.js